import { ParticipantTypeEnum } from '@clubspark-node/clubspark-tennis-types';
import { type TFunction } from 'i18next';

import { getDoublesName, getParticipantName, participantName } from 'utils/participant';

export const getPlayerNameFromMatchUp = (matchUp: any, drawPosition?: number) => {
  if (!drawPosition) {
    return '';
  }

  const side = matchUp?.sides?.find((s) => s.drawPosition === drawPosition);

  if (side?.bye === true) {
    return 'BYE';
  }

  if (side?.participant?.participantType === ParticipantTypeEnum.PAIR) {
    return getDoublesName(side?.participant);
  }

  return participantName(side?.participant);
};

export const filterParticipants = (
  data: any,
  filterValue: string,
  isDoubles: boolean,
  t: TFunction,
  replaceAlternate?: boolean,
) => {
  return data?.filter((participant) => {
    return getParticipantName(
      replaceAlternate ? participant : participant?.participant,
      isDoubles,
      t,
      !replaceAlternate && participant?.bye,
    )
      ?.toLowerCase()
      .includes(filterValue?.toLowerCase());
  });
};
